const emojiQuiz = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "emoji-quiz",
    items: [
      { id: "q1", question: "🎤☔ ", answers: ["唱歌在雨中"], image: null },
      { id: "q2", question: "🐍🐍✈️ ", answers: ["飞机上的蛇"], image: null },
      { id: "q3", question: "👻🔫 ", answers: ["捉鬼敢死队"], image: null },
      { id: "q4", question: "🐼👊 ", answers: ["功夫熊猫"], image: null },
      { id: "q5", question: "🏃‍♂️📦🍫 ", answers: ["阿甘正传"], image: null },
      { id: "q6", question: "🦁👑 ", answers: ["狮子王"], image: null },
      { id: "q7", question: "🌊🦈 ", answers: ["大白鲨"], image: null },
      { id: "q8", question: "🕷️👨 ", answers: ["蜘蛛侠"], image: null },
      { id: "q9", question: "❄️🛳️ ", answers: ["泰坦尼克号"], image: null },
      { id: "q10", question: "🤫🐑🐑 ", answers: ["沉默的羔羊"], image: null },
      { id: "q11", question: "🪐🦍🦍 ", answers: ["人猿星球"], image: null },
    ],
  },
  botId: "nualang.emoji-quiz.0.0.1",
  botName: "emoji_quiz",
  description: "emoji_quiz_desc",
  difficulty: "ALL",
  learnLang: "chinese",
  name: "德古拉伯爵",
  botAvatar:
    "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwNi5wbmcifQ==",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-smile?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# 欢迎来到电影测验
由德古拉伯爵主持。

你能说出表情符号所描绘的电影吗？
有些描绘的是电影标题，有些描绘的是情节。

对德古拉伯爵说"你好"开始。`,
  voice: "Zhiyu",
  versionQuestion: "你想在这个模板中有多少个问题？",
};

export default emojiQuiz;
